import { Button } from '@lms/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@lms/ui/dialog';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@lms/ui/dropdown-menu';
import { EllipsisVerticalIcon, Settings, TrashIcon } from 'lucide-react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslations } from 'use-intl';
import { removeLocation } from './locations-api';

// Ports _components/overflowmenu.tsx together with the shared
// DeleteConfirmationMenu (inlined here): a dropdown with a settings link and a
// delete option guarded by a confirmation dialog. The Next version relied on
// the server action's revalidatePath; the SPA revalidates via `onDeleted`.
export function OverflowMenu({
  id,
  slug,
  onDeleted,
}: {
  id: number;
  slug: string;
  onDeleted: () => void;
}) {
  const t = useTranslations('admin');
  const [warningOpen, setWarningOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    setIsDeleting(true);
    try {
      await removeLocation(id);
      setWarningOpen(false);
      onDeleted();
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <>
      <Dialog open={warningOpen} onOpenChange={setWarningOpen}>
        <DialogTrigger />
        <DialogContent>
          <DialogHeader>
            <DialogTitle>{t('are_you_sure')}</DialogTitle>
          </DialogHeader>
          <p>{t('remove_location_warning')}</p>
          <Button
            variant="destructive"
            className="w-full"
            onClick={handleDelete}
            disabled={isDeleting}
          >
            <TrashIcon className="mr-2 h-4 w-4" />
            {t('remove', { what: '' }).trim()}
          </Button>
        </DialogContent>
      </Dialog>
      <DropdownMenu modal={false}>
        <DropdownMenuTrigger>
          <EllipsisVerticalIcon />
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          <DropdownMenuItem asChild>
            <Link to={`/${slug}/admin/settings`}>
              <Settings className="mr-2 inline-block h-4 w-4" />
              {t('settings')}
            </Link>
          </DropdownMenuItem>
          <DropdownMenuItem
            className="text-destructive"
            onClick={() => setWarningOpen(true)}
          >
            <TrashIcon className="mr-2 inline-block h-4 w-4" />
            {t('remove', { what: '' }).trim()}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
}
